var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHubLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 23.436,
    viewBox: "0 0 22 23.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_28",
    "data-name": "Tracciato 28",
    d: "M3.634,2.838V22.964h7.321V5.881h2.338l-.485,4.8.361,4.386v7.9H17V2.838Z",
    transform: "translate(-3.634 -2.838)",
    fill: "#c9d3f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HubLike",
    transform: "translate(-5 -4.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon2",
    transform: "translate(4 4.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_4",
    "data-name": "Gruppo di maschere 4",
    transform: "translate(2.634 1.725)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archi",
    transform: "translate(-0.286 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26",
    "data-name": "Tracciato 26",
    d: "M4,21s9.334-1.039,9.172-9.045S21.92,2.974,21.92,2.974",
    transform: "translate(-3.777 -1.244)",
    fill: "none",
    stroke: "#c9d3f2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_27",
    "data-name": "Tracciato 27",
    d: "M22,21s-9.107-2.5-8.991-8.976S3.634,2.838,3.634,2.838",
    transform: "translate(-3.019 -1.177)",
    fill: "none",
    stroke: "#c9d3f2",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "frecce",
    transform: "translate(3.571 6.753) rotate(-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freccia",
    d: "M0,4.388,3.3,5,2.59,0Z",
    transform: "translate(3.999 8.386) rotate(47)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freccia-2",
    "data-name": "freccia",
    d: "M0,4.385,3.3,5,2.152,0Z",
    transform: "translate(8.909 4.373) rotate(151)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freccia-3",
    "data-name": "freccia",
    d: "M0,3.4,3.129,5,3.3,0Z",
    transform: "matrix(-0.515, 0.857, -0.857, -0.515, 10.55, 14.823)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freccia-4",
    "data-name": "freccia",
    d: "M0,4.817,3.3,5,1.44,0Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 15.042, 0.764)",
    fill: "#c9d3f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nodi",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_2",
    "data-name": "Ellisse 2",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 8.718)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_3",
    "data-name": "Ellisse 3",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4",
    "data-name": "Ellisse 4",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_5",
    "data-name": "Ellisse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16 17.436)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_6",
    "data-name": "Ellisse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(0 17.436)",
    fill: "#c9d3f2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubLike);
export default __webpack_public_path__ + "static/media/HubLike.c7f28cec5ce89584a2d6f6aaddc71c71.svg";
export { ForwardRef as ReactComponent };